// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 639 ? "benefits" : chunkId) + "." + {"67":"8d1da653","509":"15e0f040","639":"e3124d61","643":"31d6cfe0"}[chunkId] + ".chunk.css";
};